import React from "react";
import Draggable from "react-draggable";
import Resizer from "../Resizer";
import Formatter from "../blocks/Formatter";

const Shapes = ({ onDragStop, data }) => {
  return (
    <Draggable
      handle={`.${data.id}`}
      defaultPosition={{ x: data.pos.x, y: data.pos.y }}
      onStop={(e) => onDragStop(e, data.id)}
    >
      <div className={data.id}>
        <Formatter />
        <Resizer width={data.width && 100} height={data.height && 100} isActive={true}>
          {data.type === "rect" && (
            <svg width={data.width && 200}>
              <rect
                x="0"
                y="0"
                width={data.width && 200}
                height={data.height && 200}
                stroke="black"
                fill="red"
                stroke-width="5"
                enableBackground={true}
              />
            </svg>
          )}
        </Resizer>
      </div>
    </Draggable>
  );
};

export default Shapes;
